import {Spinner} from '@primer/react'
import {Box} from '@primer/styled-react'

export const LoadingFallback = () => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3}}>
      <Spinner aria-label="Loading" />
    </Box>
  )
}

try{ LoadingFallback.displayName ||= 'LoadingFallback' } catch {}